export function parseIGCBern(content) {
  const lines = content.split("\n");
  const dateMatch = content.match(/HFDTE(\d{2})(\d{2})(\d{2})/);

  let date = parseOrDefaultDate(content);
  const flightData = [];
  let pilotName;

  let newDay = false;
  let prevEpoch = 0;
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    const recordType = line.charAt(0);
    if (recordType == "B") {
      const timestamp = line.slice(1, 7);

      //if time difference negative than its new day
      let epoch = parseTimestamp(date, timestamp);
      if (epoch - prevEpoch < 0) {
        date = addOneDayToDate(date);
        epoch = parseTimestamp(date, timestamp);

        console.log("New Date");
      }

      prevEpoch = epoch;
      const lat = parseCoordinates(line.slice(7, 14), line[14], true);
      const lon = parseCoordinates(line.slice(15, 23), line[23], false);
      const gpsAltitude = parseInt(line.slice(30, 35), 10);
      const pressureAltitude = parseInt(line.slice(25, 30), 10);
      if (!isNaN(epoch)) {
        flightData.push({
          epoch: epoch,
          timestamp: timestamp,
          lat: lat,
          lng: lon,
          altitude: gpsAltitude,
          paltitude: pressureAltitude,
          vSpeed: 0, // Placeholder, will calculate later
        });
      } else {
        console.warn(`Skipping line with invalid epoch: ${line}`);
      }
    } else if (recordType == "H") {
      if (!pilotName) {
        pilotName = parsePilotName(line);
      }
    }
  }

  //todo discuss speed, its different from old one. Maybe becaues of pressureAlt.
  // Calculate vertical speed for each point (except the first one)
  for (let i = 1; i < flightData.length; i++) {
    const previous = flightData[i - 1];
    const current = flightData[i];
    let currAlt = current.paltitude;
    if (currAlt <= 0) currAlt = current.altitude;

    let prevAlt = previous.paltitude;
    if (prevAlt <= 0) prevAlt = previous.altitude;

    const altitudeDifference = currAlt - prevAlt;
    const timeDifference = current.epoch - previous.epoch;
    if (timeDifference !== 0) {
      current.vSpeed = altitudeDifference / timeDifference;
    }
  }

  // console.log(`Parsed ${flightData.length} flight data points`);
  if (isEmptyOrWhitespace(pilotName)) pilotName = "Anonymous";
  return { data: flightData, pilotName: pilotName };
}

function isEmptyOrWhitespace(str) {
  return str === null || str.trim().length === 0;
}

function parseCoordinates(coordStr, direction, isLatitude = true) {
  let degrees, minutes;
  if (isLatitude) {
    degrees = parseInt(coordStr.slice(0, 2));
    minutes = parseFloat(coordStr.slice(2)) / 1000.0;
  } else {
    degrees = parseInt(coordStr.slice(0, 3));
    minutes = parseFloat(coordStr.slice(3)) / 1000.0;
  }

  let decimalDegrees = degrees + minutes / 60.0;

  if (direction === "S" || direction === "W") {
    decimalDegrees = -decimalDegrees;
  }

  return decimalDegrees;
}

function parsePilotName(line) {
  if (line.slice(2, 5) == "PLT") {
    const pilotIndex = line.indexOf(":");
    if (pilotIndex !== -1) {
      return line.substring(pilotIndex + 1);
    }
  }
  return null;
}

function parseTimestamp(date, timeStr) {
  try {
    let dtStr = `${date}${timeStr}`;
    let dt = new Date(
      `20${dtStr.slice(4, 6)}-${dtStr.slice(2, 4)}-${dtStr.slice(
        0,
        2
      )}T${dtStr.slice(6, 8)}:${dtStr.slice(8, 10)}:${dtStr.slice(10, 12)}`
    );

    const timeZoneOffsetInSeconds = dt.getTimezoneOffset() * 60;
    let epochTime = Math.floor(dt.getTime() / 1000);
    const localEpochTime = epochTime - timeZoneOffsetInSeconds;
    return localEpochTime;
  } catch (e) {
    console.error(`Error parsing timestamp: ${e.message}`);
    return null;
  }
}

//todo if igc dates are different chart is not working correctly
function parseOrDefaultDate(content) {
  // const dateMatch = content.match(/HFDTE(\d{2})(\d{2})(\d{2})/);

  // if (dateMatch) {
  //     // Extracted date components from the content
  //     return dateMatch[1] + dateMatch[2] + dateMatch[3];
  // } else {
  // Use the current date if no match is found
  const currentDate = new Date();
  const day = String(currentDate.getUTCDate()).padStart(2, "0");
  const month = String(currentDate.getUTCMonth() + 1).padStart(2, "0"); // Months are zero-based
  const year = String(currentDate.getUTCFullYear()).slice(-2); // Get last two digits of year

  return `${day}${month}${year}`;
  // }
}

function addOneDayToDate(dateStr) {
  // Extract day, month, year from the input string
  const day = parseInt(dateStr.slice(0, 2));
  const month = parseInt(dateStr.slice(2, 4));
  const year = parseInt("20" + dateStr.slice(4, 6)); // Assuming the year is in the 21st century

  // Create a new Date object
  const date = new Date(year, month - 1, day); // Months are 0-indexed in JavaScript

  // Add one day
  date.setDate(date.getDate() + 1);

  // Format it back to 'DDMMYY'
  const newDay = String(date.getDate()).padStart(2, "0");
  const newMonth = String(date.getMonth() + 1).padStart(2, "0");
  const newYear = String(date.getFullYear()).slice(2); // Get last two digits of the year

  return `${newDay}${newMonth}${newYear}`;
}
